<div class="popup-content" mat-dialog-content>
  <h1 class="help-caption-headline" [innerHtml]="data.captionSupport | safeHTML"></h1>
  <p [innerHtml]="data.support | safeHTML"></p>
  <div class="buttons">
    <button mat-raised-button mat-dialog-close>Schließen</button>
  </div>
</div>
